<template>
  <app-client-layout title="Purchase">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        模試購入ページ
      </h2>
    </template>

    <div
      v-for="examination in examinations"
      :key="examination.id">
      <div class="bg-white shadow overflow-hidden sm:rounded-lg m-10">
        <div class="px-4 py-5 sm:px-6">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            {{ examination.title }}
          </h3>
        </div>

        <div class="border-t border-gray-200">
          <dl>
            <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">
                料金
              </dt>
              <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                ¥2,800
              </dd>
            </div>
            <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">
                試験実施期間
              </dt>
              <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                2022/1/24 - 2022/1/31
              </dd>
            </div>
            <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">
                試験実施期間
              </dt>
              <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                2022/1/24 - 2022/1/31
              </dd>
            </div>
            <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <button
                v-if="!isPurchased(examination.id)"
                class="mt-2 px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                :disabled="isPurchased(examination.id)"
                @click="submit">
                購入する
              </button>
              <button
                v-if="isPurchased(examination.id)"
                class="mt-2 px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                :disabled="isPurchased(examination.id)"
                @click="submit">
                購入済み
              </button>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </app-client-layout>
</template>

<script setup>
import { loadStripe } from '@stripe/stripe-js'
import { ref, onBeforeMount } from 'vue'
import AppClientLayout from '@/Layouts/AppClientLayout'

const props = defineProps({
  session: {
    type: Object,
    default: () => {},
  },
  examinations: {
    type: Array,
    default: () => ([]),
  },
  purchases: {
    type: Array,
    default: () => ([]),
  },
})

const stripe = ref({})
const stripeKey = ref(process.env.MIX_STRIPE_PUBLISHABLE_KEY)

onBeforeMount(async () => {
  stripe.value = await loadStripe(stripeKey.value)
})

const submit = () => {
  stripe.value.redirectToCheckout({ sessionId: props.session.id })
}
const isPurchased = (id) => props.purchases.filter(purchase => purchase.exam_id === id).length
</script>
